import { Validators } from '@angular/forms';
import _ from 'lodash';

export const CampaignSponsorSchema = {
    fields: [{
        field: 'imageFile',
        value: null,
        validators: [],
        options: {
            virtual: true
        }
    }, {
        field: 'id',
        value: null,
        validators: [],
    }, {
      field: 'imageDataUrl',
      value: '/images/blank_2x1.png',
      validators: [],
      options: {
        virtual: true,
        getter: (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value;
        },
        setter: (data, value) => {
          return _.get(data, 'imageUrl', '') === '' ? '/images/blank_2x1.png' : data.imageUrl;
        }
      }
    }, {
      field: 'imageUrl',
      value: '/images/blank_2x1.png',
      validators: [Validators.required],
      options: {
        getter: (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value;
        },
        setter: (data, value) => {
          return value === '' ? '/images/blank_2x1.png' : value;
        }
      }
    }, {
        field: 'name',
        value: '',
        validators: [Validators.maxLength(128)]
    }, {
      field: 'sponsorUrl',
      value: '',
      validators: [Validators.pattern('^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$')],
    }]
};

export const SponsorGroupSchema = {
    arrays: [{
        array: 'sponsors',
        schema: CampaignSponsorSchema,
        value: [],
        validators: []
    }],
    fields: [{
        field: 'name',
        value: '',
        validators: [Validators.required]
    }]
};
